/**
 * Human-readable byte size (base 1024), aligned with Laravel `ByteFormatter`.
 */
export function formatBytes(bytes: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let value = Math.max(bytes, 0);
  let pow = Math.floor(value > 0 ? Math.log(value) / Math.log(1024) : 0);
  pow = Math.min(pow, units.length - 1);
  value /= 1024 ** pow;
  return `${Math.round(value * 100) / 100} ${units[pow]}`;
}
